import { useState, useEffect } from 'react';
import { Input } from '../../ui/input';
import { Label } from '@radix-ui/react-label';
import GrandParentsBranch from './GrandParentsBranch';
 
const ShowParents = () => {
    const [father, setFather] = useState({});
    const [mother, setMother] = useState({});
 
    useEffect(() => {
        const fatherData = {
            nom: localStorage.getItem('lastnamefather') || '',
            prénom: localStorage.getItem('firstnamefather') || '',
            naissance: localStorage.getItem('birthbornfather') || '',
            lieu: localStorage.getItem('birthplacefather') || ''
        };
 
        const motherData = {
            nom: localStorage.getItem('lastnamemother') || '',
            prénom: localStorage.getItem('firstnamemother') || '',
            naissance: localStorage.getItem('birthbornmother') || '',
            lieu: localStorage.getItem('birthplacemother') || ''
        };
 
        setFather(fatherData);
        setMother(motherData);
    }, []);
 
    // ✅ Vérifie que les données importantes sont présentes
    const hasFatherData = father.nom || father.prénom;
    const hasMotherData = mother.nom || mother.prénom;
 
    if (!hasFatherData && !hasMotherData) {
        return null; // Ne rien afficher si aucun parent n'a de données
    }
 
    return (
        <div className='flex flex-col items-center justify-center p-6'>
            <div className="flex flex-col md:flex-row gap-6 justify-center w-full">
                {/* Père */}
                {hasFatherData && (
                    <div className="mx-auto w-full max-w-md">
                        <div className='p-10 bg-white dark:bg-black flex items-start justify-center'>
                            <div className="w-full border border-gray-700 rounded-lg p-6 shadow-md dark:bg-neutral-900 bg-gray-100">
                                <p className='text-2xl font-bold text-black dark:text-white'>{father.nom} {father.prénom}</p>
                            </div>
                        </div>
                    </div>
                )}
 
                {/* Mère */}
                {hasMotherData && (
                    <div className="mx-auto w-full max-w-md">
                        <div className='p-10 bg-white dark:bg-black flex justify-center'>
                            <div className="w-full border border-gray-700 rounded-lg p-6 shadow-md dark:bg-neutral-900 bg-gray-100">
                                <p className='text-2xl font-bold text-black dark:text-white'>{mother.nom} {mother.prénom}</p>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};
 
const Father = () => {
    const [lastName, setLastName] = useState(() => localStorage.getItem('lastnamefather') || '');
    const [firstName, setFirstName] = useState(() => localStorage.getItem('firstnamefather') || '');
 
    const handleChangeFirstName = (e) => {
        setFirstName(e.target.value);
        localStorage.setItem('firstnamefather', e.target.value)
    };
 
    const handleChangeLastName = (e) => {
        const upperCaseValue = e.target.value.toUpperCase();
        setLastName(upperCaseValue);
        setTimeout(() => {
            localStorage.setItem('lastnamefather', e.target.value)
        }, 100);
    };
 
    return (
        <form className='w-full'>
            <div className='p-2 bg-white dark:bg-black flex justify-center'>
                <div className="w-full max-w-md rounded-lg p-4 shadow-md dark:bg-neutral-900 bg-gray-100">
                    <h1 className='text-black dark:text-white text-xl font-semibold mb-4'>Mettez le nom de votre père</h1>
                    <div className='mb-4'>
                        <Label className='text-lg font-bold text-black dark:text-white' htmlFor="father-lastname">Nom de votre père</Label>
                        <Input value={lastName} onChange={handleChangeLastName} type="text" className="w-full" id="father-lastname" placeholder="Entrez le nom de votre père" />
                    </div>
                    <div className='mb-4'>
                        <Label className='text-lg font-bold text-black dark:text-white' htmlFor="father-firstname">Prénom de votre père</Label>
                        <Input value={firstName} onChange={handleChangeFirstName} type="text" className="w-full" id="father-firstname" placeholder="Entrez le prénom de votre père" />
                    </div>
                    <div className='mb-4'>
              
                    </div>
                </div>
            </div>
        </form>
    );
};
 
const Mother = () => {
    const [lastName, setLastName] = useState(() => localStorage.getItem('lastnamemother') || '');
    const [firstName, setFirstName] = useState(() => localStorage.getItem('firstnamemother') || '');
 
 
    const handleChangeFirstName = (e) => {
        setFirstName(e.target.value);
        localStorage.setItem('firstnamemother', e.target.value)
    };
 
    const handleChangeLastName = (e) => {
        const upperCaseValue = e.target.value.toUpperCase();
        setLastName(upperCaseValue);
        setTimeout(() => {
            localStorage.setItem('lastnamemother', e.target.value)
        }, 100);
    };
 
    return (
        <form className='w-full'>
            <div className='p-2 bg-white dark:bg-black flex justify-center'>
                <div className="w-full max-w-md rounded-lg p-4 shadow-md dark:bg-neutral-900 bg-gray-100">
                    <h1 className='text-black dark:text-white text-xl font-semibold mb-4'>Mettez le nom de jeune fille de votre mère</h1>
                    <div className='mb-4'>
                        <Label className='text-lg font-bold text-black dark:text-white' htmlFor="mother-lastname">Nom de jeune fille de votre mère</Label>
                        <Input value={lastName} onChange={handleChangeLastName} type="text" className="w-full" id="mother-lastname" placeholder="Entrez le nom de votre mère" required/>
                    </div>
                    <div className='mb-4'>
                        <Label className='text-lg font-bold text-black dark:text-white' htmlFor="mother-firstname">Prénom de votre mère</Label>
                        <Input value={firstName} onChange={handleChangeFirstName} type="text" className="w-full" id="mother-firstname" placeholder="Entrez le prénom de votre mère" required/>
                    </div>
                </div>
            </div>
        </form>
    );
}
 
const Parents = ({setShowData, setShowFamilyTree, setShowParents}) => {
    const [father, setFather] = useState({});
    const [mother, setMother] = useState({});
    const [parents, setParents] = useState(true);
    const [showP, setShowP] = useState(false);
    const [showGP, setShowGP] = useState(false);
    const [checkAll, setCheckAll] = useState(false)

    const validateAllFields = () => {
        // Récupérer les données du localStorage
        const fatherLastName = localStorage.getItem('lastnamefather') || '';
        const fatherFirstName = localStorage.getItem('firstnamefather') || '';
        
        const motherLastName = localStorage.getItem('lastnamemother') || '';
        const motherFirstName = localStorage.getItem('firstnamemother') || '';

        // Vérifier que tous les champs sont remplis (après avoir supprimé les espaces)
        const allFieldsFilled = 
            fatherLastName.trim() !== '' &&
            fatherFirstName.trim() !== '' &&
            motherLastName.trim() !== '' &&
            motherFirstName.trim() !== ''

        return allFieldsFilled;
    };

    const handleSubmitDataParents = () => {
        // Vérifier si tous les champs sont remplis
        if (!validateAllFields()) {
            setCheckAll(true);
            // Faire disparaître le message d'erreur après 5 secondes
            setTimeout(() => {
                setCheckAll(false);
            }, 5000);
            return;
        }

        // Si tout est OK, continuer
        setCheckAll(false);
        setShowP(true);
        setParents(false);
        setShowGP(true);

        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    };
 
    const backTo = () => {
        setShowParents(false)
        setShowData(false)
        setShowFamilyTree(true)
    };
 
    return (
        <div>
            {parents && (
                <div>
                    <div className="flex flex-col items-center justify-center space-y-6 p-6">
                        {/* Responsive row for forms */}
                        <div className="flex flex-col md:flex-row w-full justify-center items-start">
                            <Father onDataChange={setFather} />
                            <Mother onDataChange={setMother} />
                        </div>
 
                        {/* Buttons */}
                        <div className="flex flex-col sm:flex-row gap-4 mt-4">
                            <button
                                type="button"
                                onClick={backTo}
                                className="py-4 px-8 text-xl font-bold rounded-xl border border-transparent bg-blue-100 text-blue-800 hover:bg-blue-200 dark:text-blue-400 dark:bg-blue-800/30 dark:hover:bg-blue-800/20"
                            >
                                Revenez sur le formulaire précédent
                            </button>
                            <button
                                type="button"
                                onClick={handleSubmitDataParents}
                                className="py-4 px-8 text-xl font-bold rounded-xl border border-transparent bg-green-100 text-green-800 hover:bg-green-200 dark:text-green-400 dark:bg-green-800/30 dark:hover:bg-green-800/20"
                            >
                                Continuer votre arbre
                            </button>
                        </div>
                    </div>
                    {checkAll && <p className='text-lg text-red-500'>Tous les champs doivent être OBLIGATOIREMENT remplis</p>}
                </div>
            )}
            {showGP && <GrandParentsBranch setParents={setParents} setShowGP={setShowGP} setShowParents={setShowP}/>}
            {showP && <ShowParents father={father} mother={mother} />}
        </div>
    );
};
 
export default Parents;